var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.996,
    height: 285.453,
    viewBox: "0 0 309.996 285.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#efeeff;}.b,.c,.d{fill:#fff;}.b,.c,.e,.h,.i,.j{stroke:#403290;}.c,.e,.f,.h,.i,.j{stroke-linecap:round;}.c,.e,.f,.h,.i{stroke-linejoin:round;}.c,.e,.f,.h{fill-rule:evenodd;}.e,.f,.i,.j,.l,.n{fill:none;}.f{stroke:#000;}.g,.h{fill:#403290;}.k{fill:#f90353;}.l{stroke:#fff;}.m{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-410.004 -4385.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-15667.2,77c-9.181,0-18.743-.369-28.421-1.1l-.463-8.035-2.132-18.892-2.849-20.213-.437-3.159-11.449-26.686-24.49-18.622-7.638-2.077-1.138-.362v-9.321c-.062-.034-.361-.212-.34-.452.024-.267.42-.517,1.175-.741a26.249,26.249,0,0,0,5.837-3.357c.479-.326.93-.634,1.36-.919,1.027-.677,4.607-3.541,7.55-11.954,2.354-6.721,1.937-15.355-1.09-22.532a19.083,19.083,0,0,0-4.985-7.173,9.779,9.779,0,0,0-2.7-1.743l-25.814,8.915-4.988,73.883a369.658,369.658,0,0,0-4.977,37.435c-1.2,14.979-1.17,29.23-1.043,36.392-11.718-1.173-21.525-3.9-29.152-8.1a98.387,98.387,0,0,1-18.983-13.306,62.443,62.443,0,0,1-12.4-15.373,54.591,54.591,0,0,1-3.867-8.531,57.312,57.312,0,0,1-2.385-9.131,73.9,73.9,0,0,1-.533-20.174,203.329,203.329,0,0,0,.5-22.653c-.333-24.8-.711-52.915,22.944-74.5,9.881-9.018,22.4-15.572,37.2-19.482a139.783,139.783,0,0,1,35.59-4.291c7.52,0,13.541.493,17.139.788l.925.075c1.878.15,4.253.226,7.06.226,6.659,0,15.63-.437,24.611-1.2,9.259-.786,17.445-1.812,23.053-2.889,7.8-1.5,20.238-5.731,29.3-9.021,11.424-4.148,21.762-8.351,26.532-10.5a11.88,11.88,0,0,1,3.545-1.233c.2,0,.333.052.4.159.183.313-.244,1.076-.784,2.042-.9,1.613-2.139,3.818-1.578,5.667a3.724,3.724,0,0,0,2.034,2.181,8.9,8.9,0,0,0,3.83.626c6.206,0,17.263-2.718,25.039-4.763,2.841-.747,5.577-1.493,7.992-2.152l.013,0c5.334-1.455,9.547-2.6,10.659-2.6.171,0,.27.027.292.081.173.424-1.033,1.333-2.561,2.483a30.856,30.856,0,0,0-4.662,4.028c-1.508,1.744-1.9,3.222-1.187,4.52,1.4,2.563,13.937,4.121,25,5.5,8.187,1.017,15.256,1.9,16.487,2.994a.6.6,0,0,1,.193.478c-.039,2.132-7.744,8.525-15.9,15.294-7.365,6.112-14.979,12.429-17.371,15.982a4.549,4.549,0,0,0-.745,3.525c.83,4.233,7.171,8.482,11.8,11.585,2.827,1.894,5.06,3.39,5.043,4.212-.024,1.118-2.743,2.309-5.893,3.688-4.006,1.755-8.986,3.936-10.207,6.794a1.433,1.433,0,0,0-.079,1.219c.35.716,1.56,1.032,3.233,1.471a19.456,19.456,0,0,1,8.855,4.295,17.562,17.562,0,0,1,4.055,5.753,32.31,32.31,0,0,1,2.458,9.779c.17,1.57.371,3.258.584,5.046l.011.091,0,.023c.754,6.338,1.692,14.226,1.913,22.608a104.06,104.06,0,0,1-2.323,26.311,72.984,72.984,0,0,1-4.371,13.213,63.876,63.876,0,0,1-7.373,12.545,65.28,65.28,0,0,1-11.024,11.348,79.548,79.548,0,0,1-15.323,9.622c-10.715,5.2-23.877,9.043-39.121,11.426A270.544,270.544,0,0,1-15667.2,77Z",
    transform: "translate(16253.999 4528.482)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(590 4431.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 68,
    height: 68,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M302.527,245.109c8.8-10.31,30.434-35.643,32.285-37.078a6.148,6.148,0,0,1,4.871-1.227s.093-7.06.466-10.432c3.221-2.482,6.787-15.088,3.1-10.539s-8.789,8.179-12.914,12.362-45.127,34.911-48.449,36.683c-1.966,1.055-7.1,1.363-11.694,1.607s12.71,10.669,13.853,11.03S302.527,245.109,302.527,245.109Z",
    transform: "translate(251.074 4273.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12065.123,4634.8s18.8,5.1,26.421,11-11.935,13.733-11.935,13.733Z",
    transform: "translate(-11551.418 -126.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M251.42,251.71c6.715,1.334,17.742,4.491,26.467,9.1",
    transform: "translate(256.358 4254.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M284.284,317.145c4.635,27.98,9.1,67.375,3.781,76.085-8.086,13.258-63.853,12.7-74.729,2.7-3.623-3.322-5.79-47.423-.911-82.858",
    transform: "translate(268.176 4237.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12058.326,4617.506v23.819s-2.5,2.9-8.789,1.079-8.908-19.9-8.908-19.9l11.209-10.437Z",
    transform: "translate(-11550.549 -126.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M248.351,264c-2.2,1.758-5.273,1.765-7.791,1.327",
    transform: "translate(259.426 4251.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M251.42,237.06v13.746",
    transform: "translate(256.358 4259.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M240.786,218.862a18.779,18.779,0,0,0,2,.129c12.469,0,22.578-12.075,22.578-26.962,0-8.889-3.609-16.774-9.169-21.688s-33.006,13.149-15.411,48.521",
    transform: "translate(259.516 4277.886)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M326.737,257.179c5.51,1.772,17.9,5.546,23.547,5.546,5.653-1.786,59.491-37.113,63.544-41.519,3.53-5.761,1.507-14.363,2.942-18.926,2.662-.065,2.834,5.467,4.3,10.346.172.94.014-5.374-.151-9.42,8.71,3.142,9.678,8.509,8.71,14.779s-9,11.4-13.007,15.023-55.372,52.582-60.359,54.167c-4.5,1.428-26.058-1.973-34.9-3.759S326.737,257.179,326.737,257.179Z",
    transform: "translate(236.672 4268.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M259.186,275.143c4.391-18.438,42.91-8.688,49.389-3.515,2.267,7.024-1.3,27.858-6.959,31.725C293.114,304.587,254.508,294.758,259.186,275.143Z",
    transform: "translate(254.274 4251.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M229.691,39.933H143.182c-.2-6.868-.149-14.193.155-21.183.252-5.808.674-11.328,1.187-15.543,2.13,1.543,5.414,2.876,9.765,3.962A93.008,93.008,0,0,0,168.616,9.4l.017.02c3.611.3,7.353.454,11.12.454,4.3,0,8.506-.2,12.5-.589a88.245,88.245,0,0,0,11.373-1.8A41.854,41.854,0,0,0,212.671,4.4,13.794,13.794,0,0,0,218.184,0c2.118,7.076,5.989,20.511,11.507,39.933Z",
    transform: "translate(337.914 4631.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M223.946,194.162a12.254,12.254,0,0,1,.653,3.867c0,3.5-5.445,17.219-5.445,26.546,0,7.318,1.636,12.3,1.636,18.367,0,16.58-10.819,26.617-26.467,26.617s-26.158-16.968-26.223-30.743c-.079-16.889,18.654-37.616,23.2-50.35C195.1,177.7,202.344,156.9,219.7,156.9a25.875,25.875,0,0,1,11.139,2.659c2.958,1.4,5.283,3.362,5.283,4.968,0,4.749-6.335,14.686-12.2,20.641S223.946,194.162,223.946,194.162Z",
    transform: "translate(279.9 4281.664)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 5.787,
    cy: 5.546,
    rx: 5.787,
    ry: 5.546,
    transform: "matrix(1, -0.017, 0.017, 1, 495.161, 4465.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M243.437,203.813a5.646,5.646,0,1,1-.165-7.174",
    transform: "translate(261.463 4270.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M16669.67,1465.584l7.621-6.533,1.693,4.575,9.135-8.779",
    transform: "translate(-16007 2968.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M16584.984,1463l6.146,4.766",
    transform: "translate(-16007 2968.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M16564.3,1471.533l12.678,3.2-5.064,2.524,18.631,3.61",
    transform: "translate(-16007 2968.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M16636.334,1454.847l1.518-10.9",
    transform: "translate(-16007 2968.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M16673.607,1484.257l12.262,1.537",
    transform: "translate(-16007 2968.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(606.001 4447.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M619.644,4458.2c-.973-.05,0,14.057,0,14.057s11.75-6.155,11.838-6.607S620.616,4458.25,619.644,4458.2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.73c9ebca53400a560397cee3944c2c91.svg";
export { ForwardRef as ReactComponent };